import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { cn } from '../utils/cn';

const TrafficStrategy = ({ gaps }) => {
  if (!gaps || gaps.length === 0) return null;

  return (
    <div className="bg-white dark:bg-slate-900 rounded-2xl sm:rounded-3xl border border-slate-200 dark:border-slate-800 p-4 sm:p-6 shadow-sm">
      <div className="flex items-center gap-3 mb-6">
        <div className="p-2 bg-indigo-100 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400 rounded-xl">
          <SafeIcon icon={FiIcons.FiTarget} className="w-5 h-5" />
        </div>
        <div>
          <h3 className="text-[11px] sm:text-sm font-black uppercase tracking-widest text-slate-800 dark:text-slate-200">Traffic Capture Strategy</h3>
          <p className="text-[9px] sm:text-[10px] text-slate-400 font-bold uppercase tracking-wider">Low-Hanging Fruit (Positions 4-20)</p>
        </div>
      </div>

      <div className="space-y-3">
        {gaps.map((gap, i) => (
          <div key={i} className="flex flex-col sm:flex-row sm:items-center justify-between p-3 sm:p-4 bg-slate-50 dark:bg-slate-800/40 rounded-xl border border-slate-100 dark:border-slate-700/50 group hover:border-indigo-300 transition-all gap-3">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-xs sm:text-sm font-black text-slate-900 dark:text-white truncate">{gap.keyword}</span>
                <span className="text-[9px] px-1.5 py-0.5 bg-indigo-100 dark:bg-indigo-900/50 text-indigo-600 dark:text-indigo-400 rounded font-black">Pos: {gap.position}</span>
              </div>
              <div className="flex items-center gap-3 text-[10px] text-slate-400 font-bold uppercase tracking-wider">
                <span className="flex items-center gap-1"><SafeIcon icon={FiIcons.FiBarChart} className="w-3 h-3" /> {gap.volume.toLocaleString()} Vol</span>
                <span className="flex items-center gap-1 text-rose-500"><SafeIcon icon={FiIcons.FiChevronsDown} className="w-3 h-3" /> {gap.lostTraffic.toFixed(0)} Lost Clicks</span>
              </div>
            </div>
            
            <div className="flex items-center gap-2">
              <div className="px-3 py-1.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg text-[10px] font-black text-slate-600 dark:text-slate-300 uppercase tracking-widest whitespace-nowrap">
                {gap.strategy}
              </div>
              <button className="p-1.5 bg-indigo-500 text-white rounded-lg opacity-0 group-hover:opacity-100 transition-opacity">
                <SafeIcon icon={FiIcons.FiArrowRight} className="w-3.5 h-3.5" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrafficStrategy;